import { render, staticRenderFns } from "./PurchaseFail.vue?vue&type=template&id=19e9082a&"
import script from "./PurchaseFail.vue?vue&type=script&lang=js&"
export * from "./PurchaseFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports